// Draft storage is optional (restricted browsers and full storage can reject it).
// Keep the same check for ordinary unload and explicit workspace changes.
export function hasDirtyDrafts() {
  try {
    for (let index = 0; index < sessionStorage.length; index += 1) {
      const key = sessionStorage.key(index) || "";
      if (!key.startsWith("tps:")) continue;
      try {
        if (JSON.parse(sessionStorage.getItem(key) || "null")?.dirty === true) return true;
      } catch { /* Another feature's entry or an incomplete draft is not a form. */ }
    }
  } catch { /* Navigation must remain usable without storage access. */ }
  return false;
}
